import type { KeyboardEvent } from "react";
import { osStore } from "../../os/store";
import { resolveAppIcon } from "../../os/icons";

/**
 * IconTile — a 1x1 app-launcher tile on the desktop grid.
 * Renders the Lucide icon (canonical resolveAppIcon path) + label.
 * Double-click or Enter (when focused) launches the app.
 */
export function IconTile({
  moduleId,
  label,
  icon,
}: {
  moduleId: string;
  label: string;
  icon?: string;
}) {
  const Icon = resolveAppIcon(moduleId, label, icon);
  const open = () => osStore.openApp(moduleId);

  return (
    <div
      className="os-icon-tile"
      role="button"
      tabIndex={0}
      aria-label={label}
      title={label}
      onDoubleClick={open}
      onKeyDown={(e: KeyboardEvent) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open();
        }
      }}
    >
      <span className="os-icon-tile-glyph">
        <Icon size={40} strokeWidth={1.75} />
      </span>
      <span className="os-icon-tile-label">{label}</span>
    </div>
  );
}
